import React from "react";

interface StatCardProps {
  title: string;
  label: string;
  value: string;
}

/**
 * A card component for displaying a single statistic with a label and value.
 * Used for displaying rate limits, quotas, and other key metrics.
 */
export function StatCard({ title, label, value }: StatCardProps) {
  return (
    <div className="rounded-lg border border-border bg-card p-5 shadow-sm">
      <h3 className="font-semibold text-foreground mb-3 capitalize">{title}</h3>
      <div className="flex justify-between gap-4">
        <span className="text-muted-foreground">{label}:</span>
        <span className="font-mono font-semibold text-foreground">{value}</span>
      </div>
    </div>
  );
}

